export function blurBeforeReadOnlyMoreExpansion({ isMobile, blurFocusedNewAnswer, force = false }) {
    if (!isMobile || typeof blurFocusedNewAnswer !== 'function') return false

    try {
        return blurFocusedNewAnswer({ force }) === true
    } catch (e) {
        return false
    }
}
